import { ICompanyRepository } from '../domain/ICompanyRepository';
import { CompanyFilters, CompanyList } from '../domain/company';

export class ListCompaniesUseCase  {
  private companyRepository: ICompanyRepository;

  constructor(companyRepository: ICompanyRepository) {
    this.companyRepository = companyRepository;
  }

  async execute(filters: CompanyFilters): Promise<CompanyList> {
    return await this.companyRepository.get(filters);
  }

}
